import { ToastErrorApi, ToastErrorCath } from '../components/alerts/toast';

const checkInternetConnection = async (timeout = 3000) => {
  try {
    const controller = new AbortController();
    // eslint-disable-next-line prefer-destructuring
    const signal = controller.signal;

    // Cancelar si tarda más del timeout
    const timeoutId = setTimeout(() => controller.abort(), timeout);

    await fetch('https://www.google.com/generate_204', {
      method: 'GET',
      mode: 'no-cors', // No necesitas leer la respuesta
      signal,
    });

    clearTimeout(timeoutId);
    return true; // Si no lanza error, hay conexión
  } catch (error) {
    return false; // Si lanza error (timeout, fetch fail), no hay conexión
  }
};
const handleCatchError = async (error) => {
  const hasInternet = await checkInternetConnection();
  if (!hasInternet) {
    ToastErrorCath('- Parece que estás sin conexión. Revisa tu red y vuelve a cargar la página.');
  } else if (error instanceof TypeError) {
    ToastErrorCath('- Hubo un problema con la conexión. Por favor, inténtalo de nuevo.');
  } else {
    ToastErrorCath();
  }
};
// ************************* NEW HANDLER START *************************************

const handlerErrors = async (error) => {
  const hasInternet = await checkInternetConnection();
  if (!hasInternet) {
    ToastErrorCath('Parece que estás sin conexión. Revisa tu red y vuelve a cargar la página.');
  } else if (error.response) {
    // El servidor respondió con un status fuera del rango 2xx
    // eslint-disable-next-line prefer-destructuring
    const status = error.response?.status;
    // Inicializa el mensaje con null
    let backendMessage = null;

    const errorData = error.response?.data?.error;

    // Verifica que errorData exista y sea un objeto
    if (errorData && typeof errorData === 'object' && !Array.isArray(errorData)) {
      const firstKey = Object.keys(errorData)[0];
      if (firstKey && Array.isArray(errorData[firstKey])) {
        // eslint-disable-next-line prefer-destructuring
        backendMessage = errorData[firstKey][0];
      }
    }
    // console.log('error desde el back:', error.response);
    // console.log('error desde el back:', backendMessage);
    // si hay un status o sea un response
    if (status >= 500) {
      ToastErrorCath(`El servidor está teniendo problemas. Intenta de nuevo más tarde (status ${status}).`);
    } else if (status >= 400) {
      if (backendMessage) {
        // esto funciona en getCouters con un token invalido
        ToastErrorCath(backendMessage);
      } else {
        ToastErrorCath(`Hubo un problema con la solicitud. Verifica los datos e inténtalo de nuevo (status ${status}).`);
      }
    } else {
      // si el status no esta en rango 400 ni 500
      ToastErrorCath(`Ocurrió un error inesperado (status ${status}).`);
    }
  } else if (error.request) {
    // si hay conexion con el server pero no responde nada, axios guarda la solicitud en error.request.
    ToastErrorCath('No se pudo contactar al servidor. Revisa tu conexión o intenta más tarde.');
  } else {
    // Cualquier otro tipo de error donde axios ni siquiera pudo enviar la solicitud.
    // La URL está mal formada (ej. "htp://api" en vez de "http://api").
    // Error de CORS bloqueado por el navegador (en ciertos contextos).
    // La instancia de axios fue mal configurada.
    // Se lanzó un error manualmente (throw new Error(...)).
    // Problemas con interceptores de axios.
    ToastErrorCath('Ocurrió un error inesperado. Por favor, inténtalo más tarde (TypeError)');
  }
};
// ************************* NEW HANDLER END *************************************

const handleAPIError = (response) => {
  // recibe un obj que tiene un elemento dentro el cual obtengo su nombre
  // dinamicamente con la sig linea
  // ejemlo de la estructura del error que se espera
  // {"error": {"product_description": ["Este campo es requerido."]}, "error_code": "PARCELS-REQUEST-406"}
  const firstKey = Object.keys(response.error)[0];
  ToastErrorApi(response.error[firstKey]);
};
const handleAPIserializerError = (response) => {
  const firstKey = Object.keys(response.error)[0];
  const secondKey = Object.keys(response.error[firstKey][0])[0];
  const thirdKey = Object.keys(response.error[firstKey][0][secondKey])[0];
  ToastErrorApi(response.error[firstKey][0][secondKey][thirdKey]);
};

export { handleCatchError, handleAPIError, handleAPIserializerError, handlerErrors };
